module.exports = __webpack_public_path__ + "static/media/homepage-overlay-1.2f20acde.webp";